import { SloQualityResultDTO, SloQualityResultItemDTO } from '@atlassiansox/phobos-client-ts';

export const getQualityIssueCount = (quality?: SloQualityResultDTO): number =>
  quality?.sloQualityResultItems?.filter((item: SloQualityResultItemDTO) => item.hasQualityIssue)
    .length ?? 0;

export const getQualityWarningCount = (quality?: SloQualityResultDTO): number =>
  quality?.sloQualityResultItems?.filter(
    (item: SloQualityResultItemDTO) => !!item.metaData?.warning
  ).length ?? 0;

export const isQualityAvailable = (quality?: SloQualityResultDTO): boolean =>
  !!quality?.resultItemsCount && quality.resultItemsCount > 0;
